// import App from './App.svelte';
import CompareTable from './CompareTable.svelte';

const app = new CompareTable({
	target: document.getElementById('comparison'),
	props: {
		columnName: "Country",
		title: "Comparison table of Nuclear Victim Compensation System"
	}
});

export default app;
